<template>
	<div class="container-fluid" id="dashboard_wrap">
		<div class="row">
			<div class="col-12 text-center p-4">
				<img
					:src="this.$store.state.layout.logo"
					alt="iAMc"
					class="img-fluid p-2"
					id="iamc_logo"
				/>
				<h5 class="pt-1">
					<i class="far fa-question-circle fa-1x gold pointer" v-b-toggle.more_info></i>
					Coopetition Board <small>Rolling Weekly Ranking of Muse Meditating</small>
				</h5>
			</div>

			<b-collapse id="more_info" class="col-12">
				<b-card class="w-100">
					<h5>Notes about the displayed data</h5>
					<div v-html="notes"></div>
				</b-card>
			</b-collapse>

			<div class="col-12 text-center mb-4 table-responsive">
				<b-table
					bordered
					selectable
					table-class="text-left small"
					:items="tableData"
					:busy="isBusy"
					:fields="fields"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					sort-icon-left
				>
					<template v-slot:table-busy>
						<div class="text-center my-2 p-2">
							<b-spinner class="align-middle"></b-spinner>
							<br />
							<strong>Loading...</strong>
						</div>
					</template>

					<template v-slot:cell(name)="data">
						<div class="">
							<span v-text="data.item.name"></span>
						</div>
					</template>

					<template v-slot:cell(mon)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Mon) >= 10 }">
							<b v-text="data.item.days.Mon.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Mon.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Mon)"></b> <small>p/m (avg)</small>
						</div>
					</template>

					<template v-slot:cell(tue)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Tue) >= 10 }">
							<b v-text="data.item.days.Tue.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Tue.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Tue)"></b> <small>p/m (avg)</small>
						</div>
					</template>

					<template v-slot:cell(wed)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Wed) >= 10 }">
							<b v-text="data.item.days.Wed.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Wed.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Wed)"></b> <small>p/m (avg)</small>
						</div>
					</template>

					<template v-slot:cell(thu)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Thu) >= 10 }">
							<b v-text="data.item.days.Thu.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Thu.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Thu)"></b> <small>p/m (avg)</small>
						</div>
					</template>

					<template v-slot:cell(fri)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Fri) >= 10 }">
							<b v-text="data.item.days.Fri.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Fri.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Fri)"></b> <small>p/m (avg)</small>
						</div>
					</template>

					<template v-slot:cell(sat)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Sat) >= 10 }">
							<b v-text="data.item.days.Sat.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Sat.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Sat)"></b> <small>p/m (avg)</small>
						</div>
					</template>

					<template v-slot:cell(sun)="data">
						<div class="" :class="{ gold: birdAverage(data.item.days.Sun) >= 10 }">
							<b v-text="data.item.days.Sun.birds"></b> <small>birds</small><br />
							<b v-text="Math.ceil(data.item.days.Sun.time)"></b> <small>mins</small><br />
							<b v-text="birdAverage(data.item.days.Sun)"></b> <small>p/m (avg)</small>
						</div>
					</template>
				</b-table>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'Muse',
	components: {},
	props: {},
	data() {
		return {
			isBusy: true,
			sortBy: 'total',
			sortDesc: true,
			tableData: null,
			fields: [
				{ key: 'rank', sortable: true },
				{ key: 'name', sortable: true },
				{ key: 'mon', sortable: false, variant: this.setColumnCol('Mon') },
				{ key: 'tue', sortable: false, variant: this.setColumnCol('Tue') },
				{ key: 'wed', sortable: false, variant: this.setColumnCol('Wed') },
				{ key: 'thu', sortable: false, variant: this.setColumnCol('Thu') },
				{ key: 'fri', sortable: false, variant: this.setColumnCol('Fri') },
				{ key: 'sat', sortable: false, variant: this.setColumnCol('Sat') },
				{ key: 'sun', sortable: false, variant: this.setColumnCol('Sun') },
				{ key: 'total_birds', label: 'Total Birds', sortable: true, class: 'text-center' },
				{
					key: 'time_display',
					label: 'Total Time (H:m)',
					sortable: true,
					class: 'text-center',
				},
				{ key: 'bird_average', label: 'avg Birds p/m', sortable: true, class: 'text-center' },
			],
			notes: '',
		};
	},
	methods: {
		setColumnCol(day) {
			var d = new Date();
			var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
			var today = days[d.getDay()];
			if (today === day) {
				return 'secondary';
			}
		},
		boardDataGet() {
			let _this = this;
			axios({
				url: _this.$store.state.api_url + 'boardDataMeditationMuseGet',
				params: {},
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.tableData = Object.values(response.data.leaderboard);
						_this.notes = response.data.notes;
					} else {
						_this.tableData = null;
					}
				})
				.catch(function () {
					console.log('Error: boardDataMeditationMuseGet.');
				});
		},
		birdAverage(vars) {
			var val = 0;
			if (parseInt(vars.time) > 0) {
				var mins = Math.ceil(vars.time);
				val = Math.ceil(vars.birds / mins);
			}
			return val;
		},
	},
	mounted() {
		this.boardDataGet();
	},
	computed: {},
};
</script>

<style>
.table td.table-primary {
	font-size: 1.2rem !important;
	font-weight: bold !important;
}
.table td.table-secondary {
	text-align: left !important;
	color: #000 !important;
	background-color: rgba(146, 146, 146, 0.15);
	font-size: 1rem !important;
	border: 2px solid #000;
	border-bottom: 0;
	border-top: 0;
}
.table th.table-secondary {
	font-size: 1.3rem !important;
	text-align: center;
	border: 2px solid #000;
}
.table th {
	min-width: 100px;
}
</style>
